module.exports = __webpack_public_path__ + "img/8010.603c169a.gif";